import React, { PropTypes } from 'react';

class IconLink extends React.Component {
    static propTypes = {
        href: PropTypes.string.isRequired,
    };

    componentWillMount() {
        require('./IconLink.styl');
    }

    render() {
        return (
            <a href={this.props.href} className="IconLink">
                <img src={this.props.icon} />
                <span>{this.props.children}</span>
            </a>
        );
    }
}

export default IconLink;


// WEBPACK FOOTER //
// ./src/components/IconLink/index.js